import { render } from "./App.vue?vue&type=template&id=7b563b78&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=7b563b78&lang=css"

import exportComponent from "/Users/isamu/ss/kochi-bus/photo_admin_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__